<template>
  <v-layout column>
    <v-flex>
      <v-container
        fluid
        wrap
        grid-list-md
      >
        <v-toolbar flat>
          <v-toolbar-title>Eintrag hinzufügen</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-menu left offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on"><v-icon v-if="!profileLoading">mdi-dots-vertical</v-icon>
              <v-progress-circular v-else indeterminate /></v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="profile.keep_employee_in_edit"
                      :disabled="profileLoading"
                      @change="updateKeepEmployeeInEdit"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    Mitarbeiter beim Speichern beibehalten
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="profile.keep_project_in_edit"
                      :disabled="profileLoading"
                      @change="updateKeepProjectInEdit"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    Projekt beim Speichern beibehalten
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="profile.increment_taskday_on_save"
                      :disabled="profileLoading"
                      @change="updateIncrementTaskdayOnSave"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                   Datum beim Speichern weiterzählen
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="profile.set_filter_on_employee_selection"
                      :disabled="profileLoading"
                      @change="updateSetFilterOnEmployeeSelection"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                   Ansicht bei Mitarbeiterauswahl filtern
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
        </v-toolbar>
        <Edit
          clear-on-save
          flat
          @saved="get"
          @employeeChange="onEditEmployeeChange"
        />
      </v-container>
    </v-flex>

    <v-flex>
      <Kanban
        :data="data"
        @saved="get"
        @deleted="get"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import {api, endpoints} from '@/api'
import Edit from './Edit'
import Kanban from './Kanban'

export default {
  metaInfo: {
    title: 'Wochenansicht',
  },
  components: {
    Edit,
    Kanban,
  },
  data () {
    return {
      data: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'profile',
      'profileLoading',
      'selectedEmployees',
      'selectedPeriod',
      'selectedProjects',
      'selectedTenant',
    ]),
    filters () {
      if (this.selectedTenant === null) {
        return null
      }
      const r = {
        tenant: this.selectedTenant,
        taskday__gte: this.selectedPeriod.start.format("YYYY-MM-DD"),
        taskday__lte: this.selectedPeriod.end.format("YYYY-MM-DD"),
      }
      if (this.selectedEmployees.length > 0) {
        r.employee__in = [...this.selectedEmployees.map(i => i.id)]
      }
      if (this.selectedProjects.length > 0) {
        r.project__in = [...this.selectedProjects.map(i => i.id)]
      }
      return r
    },
  },
  watch: {
    filters: {
      handler () {
        this.get()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setProfile", "updateSelectedEmployees"]),
    async get () {
      this.loading = true
      if (this.filters === null) {
        return
      }
      try {
        const r = await api(endpoints.fetch_log(), this.filters, {method: 'GET'})
        if (r.ok) {
          this.data = await r.json()
        } else {
          // TODO: error handling
        }
      } catch (err) {
        // TODO: error handling
      } finally {
        this.loading = false
      }
    },
    updateKeepEmployeeInEdit (newValue) {
      this.setProfile({profile: {keep_employee_in_edit: newValue}})
    },
    updateKeepProjectInEdit(newValue) {
      this.setProfile({profile: {keep_project_in_edit: newValue}})
    },
    updateIncrementTaskdayOnSave(newValue) {
      this.setProfile({profile: {increment_taskday_on_save: newValue}})
    },
    updateSetFilterOnEmployeeSelection (newValue) {
      this.setProfile({profile: {set_filter_on_employee_selection: newValue}})
    },
    onEditEmployeeChange (employee) {
      if (employee && this.profile.set_filter_on_employee_selection) {
        this.updateSelectedEmployees({employees: [{id: employee.id}]})
      }
    },
  },
}
</script>
